import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield, Loader2 } from 'lucide-react';

const DataPrivacyCard = ({
  consent,
  consentDate,
  onToggle,
  loading
}) => {
  const { t, i18n } = useTranslation();

  const formatDate = (isoDate) => {
    if (!isoDate) return '';
    return new Date(isoDate).toLocaleDateString(i18n.language, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <div className="card-elevated p-4">
      <h2 className="text-lg font-bold text-secondary mb-3">
        {t('settings.data_privacy')}
      </h2>

      <button
        onClick={onToggle}
        disabled={loading}
        className="w-full flex items-center gap-3 py-3 cursor-pointer text-left"
      >
        <Shield size={24} className={consent ? 'text-primary' : 'text-text-muted'} />
        <div className="flex-1">
          <p className="text-sm font-semibold text-text">
            {t('settings.share_with_admins')}
          </p>
          <p className="text-xs text-text-muted">
            {t('settings.share_with_admins_desc')}
          </p>
          {consentDate && (
            <p className="text-xs text-text-muted mt-1">
              {t('settings.last_changed')}: {formatDate(consentDate)}
            </p>
          )}
        </div>
        {loading ? (
          <Loader2 size={20} className="animate-spin text-primary" />
        ) : (
          <div className={`w-12 h-6 rounded-full transition-colors ${consent ? 'bg-success' : 'bg-border'}`}>
            <div className={`w-5 h-5 rounded-full bg-white shadow mt-0.5 transition-transform ${consent ? 'translate-x-6' : 'translate-x-0.5'}`} />
          </div>
        )}
      </button>
    </div>
  );
};

export default DataPrivacyCard;
